import { buildPublicUrlFromSlug } from 'utils/publicUrlRule';

export function getHrefLang(
  slug: string[],
  defaultLocale: string,
  availableLocales: string[],
  canonicalHostname?: string | null,
) {
  const hrefLangs = [];
  const defaultSlug = [...slug];
  defaultSlug[1] = defaultLocale;
  const defaultUrl = buildPublicUrlFromSlug(defaultSlug, canonicalHostname);
  hrefLangs.push({ rel: 'canonical', hrefLang: defaultLocale, href: defaultUrl });
  hrefLangs.push({ rel: 'alternate', hrefLang: 'x-default', href: defaultUrl });
  availableLocales.forEach((locale) => {
    const slugClone = [...slug];
    slugClone[1] = locale;
    if (locale !== defaultLocale) {
      const url = buildPublicUrlFromSlug(slugClone, canonicalHostname);
      hrefLangs.push({ rel: 'alternate', hrefLang: locale, href: url });
    }
  });
  return hrefLangs;
}
